import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

export const TestPage: React.FC = () => {
  console.log('🎯 TestPage レンダリング成功');
  
  return (
    <Box sx={{ p: 3, minHeight: '100vh', backgroundColor: '#f5f5f5' }}>
      <Paper sx={{ p: 3, maxWidth: 600, mx: 'auto' }}>
        <Typography variant="h4" gutterBottom color="primary">
          ✅ テストページ表示成功
        </Typography>
        <Typography variant="body1" paragraph>
          このページが表示されている場合、React アプリケーションは正常に動作しています。
        </Typography>
        <Typography variant="body2" color="text.secondary">
          現在時刻: {new Date().toLocaleString('ja-JP')}
        </Typography>
        <Box sx={{ mt: 3, p: 2, bgcolor: 'success.light', borderRadius: 1 }}>
          <Typography variant="body2">
            v2 UI の基本的な React レンダリングが機能しています。
          </Typography>
        </Box>
      </Paper>
    </Box>
  );
};

export default TestPage;
